module.exports = __webpack_public_path__ + "static/media/pic6.2f0a1407.jpg";